
export class GiiAtaskVertinimasApi {
  ataskaitaId: any;
  vertintojas: any;
  vertinimoData!: Date;
  isvada: any;
  atmetimoPriezastis: any;
  vidinisKomentaras: string = '';
  subjektasKomentaras: string = '';
  tikslinimoTerminas: any;
  senaBusena: any;
  busena: any;
  vertinimoVeiksmas: any;
  insertUser: any;
}
